import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { QRCode } from 'react-qrcode-logo';
import { useDispatch } from 'react-redux';

import { brandImage } from '../../../../config/branding';
import config from '../../../../config/config';
import { useBranding } from '../../../../contexts/BrandingContext';
import { setNotificationDetails } from '../../../../redux/slices/NotificationSlice';
import MyButton from '../../../../shared-components/button/Button';
import getFirstSubdomain from '../../../../shared-functions/DomainsplitFunction';

/**
 * Device qr code view and download
 * @param {any} properties - The properties
 * @param {any} properties.deviceSN - The deviceSN prop
 * @param {any} properties.handleClose - The handleClose prop
 * @returns {any} The result
 */
function DeviceQrCode(properties: { deviceSN: string; handleClose: () => void }) {
  const { t } = useTranslation('partnerDeviceManagement');
  const { brandData } = useBranding();
  const domain = getFirstSubdomain();
  const { deviceSN, handleClose } = properties;

  const dispatch = useDispatch();
  const qrCodeCanvasReference = useRef<HTMLDivElement | null>(null);

  /**
   * Function to handle qr code download
   */
  const handleDownloadQRCode = () => {
    try {
      const canvas = qrCodeCanvasReference.current?.querySelector('canvas');
      if (canvas) {
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png'); // Get the PNG data URL
        link.download = `${deviceSN}.png`; // File name for download
        link.click(); // Trigger the download
      }
      handleClose();
    } catch (error) {
      dispatch(
        setNotificationDetails({
          type: 'error',
          notificationDetails: {
            statusCode: 200,
            message: t('somethingWentWrong'),
          },
        }),
      );
    }
  };

  const qrBaseUrl = domain && brandData?.qrCode ? brandData?.qrCode : config.qrCodeUrl;

  const qrValue = `${qrBaseUrl}?deviceId=${deviceSN}${domain ? `&domain=${domain}` : ''}`;

  return (
    <div className="device-qr-code-wrap-partner">
      <div ref={qrCodeCanvasReference} className="device-qr-code-container">
        <div ref={qrCodeCanvasReference} className="device-qr-code">
          <QRCode value={qrValue} logoImage={brandImage.qrLogo} removeQrCodeBehindLogo />
        </div>
      </div>
      <div className="device-qr-code-btn">
        <MyButton label={t('cancel')} buttonType="back" onClickFunc={handleClose} />
        <MyButton label={t('download')} buttonType="submit" onClickFunc={handleDownloadQRCode} />
      </div>
    </div>
  );
}

export default DeviceQrCode;
